module.exports = {"46x55": __webpack_public_path__ + "images/collision-prediction-55x46.png"};